import { render, staticRenderFns } from "./ActivityThirdParty.vue?vue&type=template&id=8cbab0b2&scoped=true&"
import script from "./ActivityThirdParty.vue?vue&type=script&lang=js&"
export * from "./ActivityThirdParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbab0b2",
  null
  
)

export default component.exports